module.exports = __webpack_public_path__ + "img/wave.de5f677d.svg";